// services/axiosInstance.js
import axios from "axios";
import Cookies from "js-cookie";
import { API_URL } from "../config/api"; 

// 🛠️ Tạo một axios instance với cấu hình mặc định
const axiosInstance = axios.create({
    baseURL: `${API_URL}/api`,
    withCredentials: true,
});

// ======================
// 📌 Request Interceptor
// ======================
// ✅ Chạy trước mỗi request → tự động gắn Access Token (nếu có) vào headers
axiosInstance.interceptors.request.use((config) => {
    const token = Cookies.get("accessToken");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// ======================
// 📌 Response Interceptor
// ======================
// ✅ Xử lý trường hợp Access Token hết hạn → tự refresh token
axiosInstance.interceptors.response.use(
    (res) => res,
    async (err) => {
        // 🔴 Nếu response lỗi → kiểm tra trường hợp token hết hạn
        const originalRequest = err.config;

        // Nếu lỗi 401 (Unauthorized) và request chưa retry → tiến hành refresh token
        if (err.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                // 🚀 Gọi API refresh token
                const refreshRes = await axios.post(
                    `${API_URL}/auth/refresh-token`,
                    null,
                    { withCredentials: true }
                );
                // Lưu Access Token mới vào cookie
                const newAccessToken = refreshRes.data.accessToken;
                Cookies.set("accessToken", newAccessToken, { expires: 7 });

                // Gắn Access Token mới vào request ban đầu
                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                // Gửi lại request cũ với token mới
                return axiosInstance(originalRequest);
            } catch (refreshErr) {
                // ❌ Nếu refresh token thất bại → xoá token và chuyển hướng về login
                Cookies.remove("accessToken");
                Cookies.remove("user");
                window.location.href = "/login";
                return Promise.reject(refreshErr);
            }
        }
        // ❌ Các lỗi khác → trả về như bình thường
        return Promise.reject(err);
    }
);

export default axiosInstance;
